import { render, staticRenderFns } from "./check-phone.vue?vue&type=template&id=358f11aa&scoped=true&"
import script from "./check-phone.vue?vue&type=script&lang=js&"
export * from "./check-phone.vue?vue&type=script&lang=js&"
import style0 from "./check-phone.vue?vue&type=style&index=0&id=358f11aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358f11aa",
  null
  
)

export default component.exports